import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../environments/environment";
import {
  CircuitBreakerStatusDto,
  UserSyncQueueListenerCommand,
  UserSyncQueueType,
  UserSyncQueuesDto
} from "admin-api-dto";

@Injectable({
  providedIn: 'root'
})
export class UserSyncService {
  constructor(private readonly http: HttpClient) {
  }

  getQueues(): Observable<UserSyncQueuesDto> {
    return this.http.get<UserSyncQueuesDto>(`${environment.apiUrl}/api/private/user-sync/queues`);
  }

  toggleListener(queue: UserSyncQueueType, enable: boolean): Observable<void> {
    const command: UserSyncQueueListenerCommand = {enable};
    return this.http.put<void>(`${environment.apiUrl}/api/private/user-sync/queues/${queue}/listener`, command);
  }

  getCircuitBreakerStatus(): Observable<CircuitBreakerStatusDto> {
    return this.http.get<CircuitBreakerStatusDto>(`${environment.apiUrl}/api/private/user-sync/circuit-breaker-status`);
  }
}
